import { LAGO_PLAN_MAP } from '../shared/utils/lagoPlanMap';
import { resolveProviderAssignment } from '../shared/utils/roundPayments';

export function useRoundPlanFallback() {
  const { $logger } = useNuxtApp();
  const gatewayStore = useKegelGatewayStore();

  function applyRoundPlanFallback(chargebeeId?: string): void {
    if (gatewayStore.railLocked) return;
    if (gatewayStore.provider !== 'round') return;
    if (chargebeeId && LAGO_PLAN_MAP[chargebeeId]) return;

    $logger.error(new Error(`Plan ${chargebeeId} has no Round code, falling back to Chargebee`), {
      tags: { flow: 'payment', step: 'round_plan_fallback' },
      extra: { chargebeeId },
    });
    // Both fields move together, or the store describes a rail that does not exist and the funnel
    // echoes the wrong subscription_service back to the backend.
    Object.assign(gatewayStore, resolveProviderAssignment('chargebee'));
  }

  return { applyRoundPlanFallback };
}
